// Media query breakpoints
export const BREAKPOINTS = {
  xs: 500,  // extra small devices (phones)
  sm: 768,  // small devices (tablets)
  md: 1024, // medium devices (small laptops)
  lg: 1280, // large devices (desktops)
  xl: 1600  // extra large devices (large desktops)
};

// Media query strings
export const MEDIA_QUERIES = {
  xs: `(max-width: ${BREAKPOINTS.xs}px)`,
  sm: `(max-width: ${BREAKPOINTS.sm}px)`,
  md: `(max-width: ${BREAKPOINTS.md}px)`,
  lg: `(max-width: ${BREAKPOINTS.lg}px)`,
  xl: `(max-width: ${BREAKPOINTS.xl}px)`,
  
  // Additional useful queries
  landscape: '(orientation: landscape)',
  portrait: '(orientation: portrait)',
  darkMode: '(prefers-color-scheme: dark)',
  lightMode: '(prefers-color-scheme: light)',
  reduceMotion: '(prefers-reduced-motion: reduce)',
  touch: '(hover: none) and (pointer: coarse)',
  mouse: '(hover: hover) and (pointer: fine)'
};

/**
 * Returns a style object with responsive values based on screen size
 * @param {Object} values - Object with values for different screen sizes
 * @param {*} defaultValue - Default value if no screen size matches
 * @returns {*} - Value for the current screen size
 * 
 * Example usage:
 * getResponsiveValue({
 *   xs: '100%',
 *   sm: '50%',
 *   md: '33%',
 *   lg: '25%',
 *   xl: '20%'
 * }, '100%')
 */
export const getResponsiveValue = (isXs, isSm, isMd, isLg, values, defaultValue) => {
  if (isXs && values.xs !== undefined) return values.xs;
  if (isSm && values.sm !== undefined) return values.sm;
  if (isMd && values.md !== undefined) return values.md;
  if (isLg && values.lg !== undefined) return values.lg;
  
  return values.default || defaultValue;
};

/**
 * Returns a responsive class name based on screen size
 * @param {Object} classNames - Object with class names for different screen sizes
 * @param {string} baseClassName - Base class name to always include
 * @returns {string} - Class names string for the current screen size
 * 
 * Example usage:
 * getResponsiveClassName({
 *   xs: 'text-sm',
 *   sm: 'text-base',
 *   md: 'text-lg',
 *   lg: 'text-xl'
 * }, 'text-color-primary')
 */
export const getResponsiveClassName = (isXs, isSm, isMd, isLg, classNames, baseClassName = '') => {
  let result = baseClassName;
  
  if (isXs && classNames.xs) result += ` ${classNames.xs}`;
  else if (isSm && classNames.sm) result += ` ${classNames.sm}`;
  else if (isMd && classNames.md) result += ` ${classNames.md}`;
  else if (isLg && classNames.lg) result += ` ${classNames.lg}`;
  else if (classNames.default) result += ` ${classNames.default}`;
  
  return result.trim();
}; 